import _ from 'lodash';
import axios from 'axios';
import { loader } from './../../layout/loader';

// ==== APP ACTIONs

/**
 * Zmienia tryb na edycję lub preview
 * @param {string} mode - nazwa trybu
 * @return {object} typ akcji i nowy tryb.
 */
export const changeMode = (mode) => {
    return {
        type: 'CHANGE_MODE',
        mode,
    };
};

/**
 * Ustawia id do quick response
 * @param {number} id - id strony zwrocone przez serwer
 */
export const setAppId = (id) => {
    return {
        type: 'SET_APP_ID',
        id,
    };
};

/**
 * Ustawia id do szablonu ze stylami
 * @param {number} id - id szablonu
 */
export const setTemplateId = (id) => {
    return {
        type: 'SET_TEMPLATE_ID',
        id,
    };
};

/**
 * Ustawia nazwe quick response
 * @param {string} name - nazwa quick response
 */
export const setAppName = (name) => {
    return {
        type: 'SET_APP_NAME',
        name,
    };
};

export const setPrimaryColor = (color) => {
    return {
        type: 'SET_PRIMARY_COLOR',
        color,
    };
};

export const setSecondaryColor = (color) => {
    return {
        type: 'SET_SECONDARY_COLOR',
        color,
    };
};

/**
 * Ustawia url do sharowania
 * @param {string} url - url do sharowania quick response
 */
export const setAppShareUrl = (url) => {
    return {
        type: 'SET_APP_SHARE_URL',
        url,
    };
};

/**
 * Ustawia adres email
 * @param {string} email - adres email klienta
 */
export const setAppEmail = (email) => {
    return {
        type: 'SET_APP_EMAIL',
        email,
    };
};

/**
 * Zapisuje Quick response
 */
export const save = () => {
    return (dispatch, getState) => {
        const isNew = _.isNull(getState().app.id);

        loader.show();

        axios({
            method: (isNew) ? 'post' : 'patch',
            url: (isNew) ? Routing.generate('app_inquiry.post') : Routing.generate('app_inquiry.patch_data', { id: getState().app.id }),
            data: getState(),
        })
        .then((response) => {
            if (isNew && response.data.status === 'success' && _.isNumber(response.data.id)) {
                dispatch(setAppId(response.data.id));
                dispatch(setAppShareUrl(response.data.shareUrl));
                // window.history.replaceState(null, null, Routing.generate('app_inquiry.get', { id: response.data.id }));
            }
            loader.hide(response);
        })
        .catch((response) => {
            console.log(response);
        });
    };
};

/**
 * Zapisuje odpowiedzi Quick response klienta
 */
export const clientSend = () => {
    return (dispatch, getState) => {
        let rootDiv = document.getElementById('quickresponse-client');
        loader.show();
        axios({
            method: 'post',
            url: Routing.generate('app_inquiry.add_response', { "token": rootDiv.getAttribute('data-token'), "domain": rootDiv.getAttribute('data-domain') }),
            data: getState(),
        })
        .then(function (response) {
            loader.hide(response);
        })
        .catch(function (response) {
            console.log(response);
        });
    };
};

// ==== PAGE ACTIONs

/**
 * Dodaje nowa podstrone
 * @param {array} pagesList - tablica z aktualnymi id stron
 * @return {object} typ akcji i nowe ID.
 */
export const addPage = (pagesList) => {
    const newId = (_.isEmpty(pagesList)) ? 1 : _.max(pagesList) + 1;
    return {
        type: 'ADD_PAGE',
        newId,
    };
};

/**
 * Usuwa podstrone
 * @param {number} id - numer strony do usuniecia
 */
export const deletePage = (id) => ({
    type: 'DELETE_PAGE',
    id,
});

/**
 * Ustawia aktywna podstronę
 * @param {number} id - numer strony
 */
export const setActivePage = (id) => ({
    type: 'SET_ACTIVE_PAGE',
    id,
});

/**
 * Ustawia strone w tryb edycji
 * @param {number} id - numer strony
 * @param {boolean} value - true lub false
 */
export const setEditingPage = (id, value) => ({
    type: 'SET_EDITING_PAGE',
    id,
    value,
});

/**
 * Usuwa podstrony lub ustawia podstrone jako aktywną
 * @param {number} id - numer strony do usuniecia
 */
export const deletePageAndSetActive = (id) => {
    return (dispatch, getState) => {
        const pagesList = getState().pages.list;
        const activePage = getState().pages.activeId;

        if (activePage === id) {
            const redirectToPage = pagesList[pagesList.indexOf(activePage) + 1];
            dispatch(setActivePage(redirectToPage));
            dispatch(deletePage(id));
        } else {
            dispatch(deletePage(id));
        }
    };
};

/**
 * Dodaje widget to strony
 * @param {number} id - numer strony do ktorej trzeba dodac widget
 * @param {number} widgetId - id widgetu
 */
export const tieWidgetToPage = (id, widgetId) => ({
    type: 'TIE_WIDGET_TO_PAGE',
    id,
    widgetId,
});

/**
 * Sortuje strony
 * @param {number} oldIndex - stary index strony w tablicy
 * @param {number} newIndex - nowy index strony
 */
export const sortPages = (oldIndex, newIndex) => {
    return {
        type: 'SORT_PAGES',
        oldIndex,
        newIndex,
    };
};

/**
 * Sortuje widgety
 * @param {number} id - id strony
 * @param {number} oldIndex - stary index widgetu na stronie
 * @param {number} newIndex - nowy index widgetu na stronie
 */
export const sortWidgets = (id, oldIndex, newIndex) => {
    return {
        type: 'SORT_WIDGETS',
        id,
        oldIndex,
        newIndex
    };
};

// ==== MODAL ACTIONs
export const setModal = (name, header, msg, vars) => {
    return {
        type: 'SET_MODAL',
        name,
        header,
        msg,
        vars,
    };
};


// ==== RESULTS ACTIONs

/**
 * Zapisuje odpowiedz na stronie
 * @param {number} id - id strony
 * @param {sting} widgetType - typ widgetu
 * @param {sting} value - wartosc zapisana na stronie
 */
export const saveResult = (id, widgetType, value) => {
    return {
        type: 'SAVE_RESULT',
        id,
        widgetType,
        value,
    };
};
/**
 * Usuwa odpowiedz ze strony
 * @param {number} id - id strony
 */
export const deleteResult = (id) => {
    return {
        type: 'DELETE_RESULT',
        id,
    };
};

/**
 * Zapisuje wyniki dla radio lub checkboxow
 * @param {array} optionIds - id aktywnych opcji w widgecie
 * @param {object} widget - obiekt widgetu
 * @param {number} activeId - id strony
 */
export const saveResultAndCheckChoiceWidget = (optionIds, widget, activeId) => {
    // console.log(optionIds);
    // console.log(widget);
    // console.log(activeId);

    return (dispatch, getState) => {
        const getValues = () => {
            let arr = [];
            _.forEach(getState().widgets.byId[widget.id].options, (option)=> {
                if (option.checked === true) {
                    arr.push(option.label);
                }
            });
            return arr;
        };

        dispatch(checkChoiceWidget(optionIds, widget.id));
        if (_.isEmpty(getValues())) {
            dispatch(deleteResult(activeId));
        } else {
            dispatch(saveResult(activeId, widget.type, getValues()));
        }
    };
};

// ==== TOOLS ACTIONs

export function setActiveWidget(id) {
    return {
        type: 'SET_ACTIVE_WIDGET',
        id,
    };
}

/**
 * Dodaje widget do kolekcji
 * @param {number} id - numer widgetu
 * @param {number} widgetTemplateId - id szablonu dla danego widgetu
 */
export function addWidget(id, widgetTemplateId) {
    return {
        type: 'ADD_WIDGET',
        id,
        widgetTemplateId,
    };
}

/**
 * Usuwa widget ze strony
 * @param {number} id - numer widgetu
 */
export function deleteWidget(id) {
    return {
        type: 'DELETE_WIDGET',
        id,
    };
}

export function setWidgetTools(kind, widgetId) {
    return {
        type: 'SET_WIDGET_TOOLS',
        kind,
        widgetId,
    };
}

export function setTextWidgetValue(id, value) {
    return {
        type: 'SET_TEXT_WIDGET_VALUE',
        id,
        value,
    };
}

/**
 * Dodaje widget do kolekcji oraz do strony
 * @param {number} widgetTemplateId - id szablonu dla danego widgetu
 */
export const addWidgetToPage = (widgetTemplateId) => {
    return (dispatch, getState) => {
        const newWidgetId = (_.isEmpty(getState().widgets.list)) ? 1 : _.max(getState().widgets.list) + 1;
        const currentPage = getState().pages.activeId;
        dispatch(addWidget(newWidgetId, widgetTemplateId));
        dispatch(tieWidgetToPage(currentPage, newWidgetId));
    };
};

// CHOICE WIDGET ACTIONS

export function checkChoiceWidget(optionIds, widgetId) {
    return {
        type: 'CHECK_CHOICE_WIDGET',
        optionIds,
        widgetId,
    };
}

export function setChoiceWidgetValue(optionId, widgetId, value) {
    return {
        type: 'SET_CHOICE_WIDGET_VALUE',
        optionId,
        widgetId,
        value,
    };
}

export function addChoiceOption(widgetId) {
    return {
        type: 'ADD_CHOICE_OPTION',
        widgetId,
    };
}

export function deleteChoiceOption(widgetId, optionId) {
    return {
        type: 'DELETE_CHOICE_OPTION',
        widgetId,
        optionId,
    };
}

// INPUT WIDGET ACTIONs

export function setInputWidgetValue(widgetId, value) {
    return {
        type: 'SET_INPUT_WIDGET_VALUE',
        widgetId,
        value,
    };
}
export function setInputWidgetPlaceholder(id, value) {
    return {
        type: 'SET_INPUT_WIDGET_PLACEHOLDER',
        id,
        value,
    };
}

// DATEPICKER WIDGET ACTIONs

export function setDateWidgetValue(widgetId, value) {
    return {
        type: 'SET_DATE_WIDGET_VALUE',
        widgetId,
        value,
    };
}
export function setDateWidgetPlaceholder(id, value) {
    return {
        type: 'SET_DATE_WIDGET_PLACEHOLDER',
        id,
        value,
    };
}

// RANGE WIDGET ACTIONs

export function setRangeMulti(widgetId, value) {
    return {
        type: 'SET_RANGE_MULTI',
        widgetId,
        value,
    };
}

export function setRangeScaleMin(widgetId, value) {
    return {
        type: 'SET_RANGE_SCALE_MIN',
        widgetId,
        value,
    };
}

export function setRangeScaleMax(widgetId, value) {
    return {
        type: 'SET_RANGE_SCALE_MAX',
        widgetId,
        value,
    };
}


export function setRangeDefaultMin(widgetId, value) {
    return {
        type: 'SET_RANGE_DEFAULT_MIN',
        widgetId,
        value,
    };
}

export function setRangeDefaultMax(widgetId, value) {
    return {
        type: 'SET_RANGE_DEFAULT_MAX',
        widgetId,
        value,
    };
}

export function setRangeStep(widgetId, value) {
    return {
        type: 'SET_RANGE_STEP',
        widgetId,
        value,
    };
}

export function setRangeUserValues(widgetId, value) {
    return {
        type: 'SET_RANGE_USER_VALUES',
        widgetId,
        value,
    };
}

export function setRangeSingleValue(widgetId, value) {
    return {
        type: 'SET_RANGE_SINGLE_VALUE',
        widgetId,
        value,
    };
}



// WEBPACK FOOTER //
// ./src/_app/quick_response/actions/actions.js